import { useIsUserInitialized } from '@providers/Auth';

const UserRehydratedGate: React.FC = ({ children }) => {
  const isUserInitialized = useIsUserInitialized();
  return isUserInitialized ? <>{children}</> : null;
};

export default UserRehydratedGate;